export default "__VITE_ASSET__Pk4i_Ycs__"